import request from "../api/httpClient";
import getEndpoint from "../utils/getEndpoint";

export const sendFeedback = async (payload) => {
  await request(getEndpoint("analytics", "sendFeedback"), {
    body: payload,
  });
};
